module.exports = __webpack_public_path__ + "static/media/Whitelogo.1043be84.svg";